import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddStaffLayer from "../components/AddStaffLayer";

const AddStaffPage = () => {
  return (
    <>
      <Breadcrumb title="Add Staff" />
      <AddStaffLayer />
    </>
  );
};

export default AddStaffPage;
